<template>
  <div> <!-- root element of the template -->
    <cm-attachments-devis-form v-if="devisForm" @close="devisForm = false" :devisFormData="devisFormData"></cm-attachments-devis-form>
    <cm-payment-axepta v-if="paymentAxepta" @close="paymentAxepta = false" :paymentDetails="paymentDetails"></cm-payment-axepta>
    <bank-account-qr-code v-if="bankAccountQRCode" @close="bankAccountQRCode = false" :accountId="accountId"></bank-account-qr-code>
    <scanner-qr-code v-if="scannerQRCode" @close="scannerQRCode = false" :content="scannerQRCodeContent"></scanner-qr-code>
    <cm-service-popups></cm-service-popups>
    <cm-service-switcher-popup :closeButton="true"></cm-service-switcher-popup>
    <cm-switch-profile :closeButton="true"></cm-switch-profile>
    <cm-user-reset-password :closeButton="true"></cm-user-reset-password>
    <!-- <cm-switch-profile :closeButton="false"></cm-switch-profile> -->
  </div>
</template>

<script>
// contacts
import CMAddContact from '@/popups/contacts/CMAddContact.vue'
import CMAddContactGroup from '@/popups/contacts/CMAddContactGroup.vue'
import CMEditContact from '@/popups/contacts/CMEditContact.vue'
// services
import CMServicePopups from '@/popups/services/Popups.vue'
// service switch
import ServicesSwitcherPopup from '@/popups/ServicesSwitcherPopup.vue'
import ProfileSwitcherPopup from '@/popups/switchProfile/switchProfile.vue'

import CMAttachmentsDevisForm from '@/popups/attachments/CMAttachmentsDevisForm.vue'
import CMPaymentAxepta from '@/popups/services/payments/CMPaymentAxepta.vue'

import BankAccountQRCode from '@/popups/bankAccounts/BankAccountQRCode.vue'

import scannerQRCode from '@/popups/services/payments/ScannerQRCode.vue'

import CMUserResetPassword from '@/popups/user/CMUserResetPassword.vue'

export default {
  name: 'cm-popups',
  components: {
    'cm-attachments-devis-form': CMAttachmentsDevisForm,
    'cm-contact-add-popup': CMAddContact,
    'cm-contact-group-add-popup': CMAddContactGroup,
    'cm-contact-edit-popup': CMEditContact,
    'cm-payment-axepta': CMPaymentAxepta,
    'cm-user-reset-password': CMUserResetPassword,
    'cm-service-popups': CMServicePopups,
    'cm-service-switcher-popup': ServicesSwitcherPopup,
    'cm-switch-profile': ProfileSwitcherPopup,
    'bank-account-qr-code': BankAccountQRCode,
    'scanner-qr-code': scannerQRCode
  },
  data: () => {
    return {
      devisForm: false,
      devisFormData: '',
      paymentAxepta: false,
      paymentDetails: '',
      bankAccountQRCode: false,
      accountId: '',
      scannerQRCode: false,
      scannerQRCodeContent: ''
    }
  },
  created () {
    this.$bus.$on('popup-devis-form', e => {
      this.devisFormData = e
      this.devisForm = true
    })
    this.$bus.$on('popup-payment-axepta', e => {
      this.paymentDetails = e
      this.paymentAxepta = true
    })
    this.$bus.$on('popup-bank-account-qr-code', e => {
      this.accountId = e
      this.bankAccountQRCode = true
    })
    this.$bus.$on('popup-scanner-qr-code', e => {
      this.scannerQRCodeContent = e
      console.log('On ', this.scannerQRCodeContent)
      this.scannerQRCode = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// Popups.vue?c44688c8